import React from 'react';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { Box, Typography } from '@material-ui/core';
import styled from 'styled-components/macro';

/**
 * update or remove this
 */
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export interface BaseOverlayProps extends DialogProps {
  open: boolean;
  handleClose: () => void;
  title?: string;
  noAppBar?: boolean;
  closeButtonStyle?: object;
  fullscreen?: boolean;
  height?: string;
}

const BaseOverlay: React.FC<BaseOverlayProps> = (props) => {
  const {
    children,
    open = true,
    handleClose,
    title,
    noAppBar,
    height,
    closeButtonStyle = {},
    fullscreen = false,
    ...rest
  } = props;
  const renderCloseButton = () => {
    return (
      <IconButton
        edge="start"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
        style={closeButtonStyle}
      >
        <CloseIcon />
      </IconButton>
    );
  };
  return (
    <SDialog
      {...rest}
      height={height}
      fullScreen={fullscreen}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      {!noAppBar && !!title ? (
        <SToolbar>
          <SHeaderLeft>
            <Typography variant="h6" color="primary">
              {title}
            </Typography>
          </SHeaderLeft>
          {renderCloseButton()}
        </SToolbar>
      ) : (
        <Box textAlign="right" position="absolute" top={0} right={0}>
          {renderCloseButton()}
        </Box>
      )}
      {children}
    </SDialog>
  );
};
export default BaseOverlay;

const SToolbar = styled(Toolbar)`
  box-shadow: ${(props) => props.theme.boxShadow.appBar};
  display: flex;
  align-items: center;

  color: ${(props) => props.theme.palette.primary.main};
`;
const SHeaderLeft = styled.div`
  display: flex;
  flex: 1;
  column-gap: 1rem;
  align-items: center;
`;
const SDialog = styled(Dialog)`
  & .MuiDialog-paper {
    background: ${(props) => props.theme.palette.background.default};
    height: ${(props: { height?: string }) => props.height};
  }
`;
